import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {Product} from "../../../../models/product";

@Injectable()
export class ProductOptionsService {


    private OptionItemSelected = new Subject<Product>();
    private OptionItemMouseOver = new Subject<Product>();
    private OptionItemMouseOut = new Subject<Product>();


    // observables
    public optionItemSelectedEvent = this.OptionItemSelected.asObservable();
    public optionItemMouseOverEvent = this.OptionItemMouseOver.asObservable();
    public optionItemMouseOutEvent = this.OptionItemMouseOut.asObservable();


    EmitOptionItemSelectedEvent(product) {
        this.OptionItemSelected.next(product);
    }

    EmitOptionItemMouseOverEvent(product) {
        this.OptionItemMouseOver.next(product);
    }

    EmitOptionItemMouseOutEvent(product) {
        this.OptionItemMouseOut.next(product);
    }


}
